import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer, on } from '@ngrx/store';
import { AppStartStates } from './app-start-state.enum';
import {
   authenticationVerificationFailure,
   authenticationVerificationSuccess,
   unverifiedSessionFound,
} from './app-start.actions';

export interface AppStartState {
   callState: CallState;
   startupStep: AppStartStates;
}

export const initialState: AppStartState = {
   callState: LoadingState.Init,
   startupStep: AppStartStates.Init,
};

const reducer = createReducer(
   initialState,

   on(unverifiedSessionFound, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         startupStep: AppStartStates.VerifyingSession,
      };
   }),
   on(authenticationVerificationSuccess, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
         startupStep: AppStartStates.Complete,
      };
   }),
   on(authenticationVerificationFailure, (state, action) => {
      return {
         ...state,
         callState: action.error,
         startupStep: AppStartStates.SessionInvalid,
      };
   })
);

export function appStartReducer(state: AppStartState | undefined, action: Action) {
   return reducer(state, action);
}
